const systemImageText = document.querySelectorAll('.text-over-image-sticky__item--full-width');

if (systemImageText) {
  systemImageText.forEach((element) => {
    let controllerImageTextModule = null;
    controllerImageTextModule = new ScrollMagic.Controller();

    const image = element.querySelector('.text-over-image-sticky__image');
    const enlargeStartPoint = element.querySelector('.text-over-image-sticky__enlarge-start');
    const stickyStartPoint = element.querySelector('.text-over-image-sticky__sticky-start');
    const textStartPoint = element.querySelector('.text-over-image-sticky__text-start');
    const stickyElement = element.querySelector('.text-over-image-sticky__sticky-body');
    const content = element.querySelector('.text-over-image-sticky__text');
    const imageMask = element.querySelector('.text-over-image-sticky__image-mask');

    // Image enlarge animation
    const enlargeImageScene = () => {
      const enlargeImage = new TimelineLite();
      const imageTween = enlargeImage.to(image, {
        width: window.innerWidth,
        height: window.innerHeight,
        opacity: 1,
      });

      const scene = new ScrollMagic.Scene({
        triggerElement: enlargeStartPoint,
        duration: enlargeStartPoint.clientHeight,
        triggerHook: 1,
      })
        .setTween(imageTween)
        .addTo(controllerImageTextModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Enlarge Image' });
      }
    };

    // Sticky image
    const stickyImageScene = () => {
      const scene = new ScrollMagic.Scene({
        triggerElement: stickyStartPoint,
        duration: stickyStartPoint.clientHeight,
        triggerHook: 0,
      })
        .setPin(stickyElement)
        .addTo(controllerImageTextModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Sticky Element' });
      }
    };

    // Show Content

    const showTextScene = () => {
      const showText = new TimelineMax();
      const textTween = showText
        .to(content, {
          y: windowWidth() < breakpointSm ? '10%' : '-45%',
          opacity: 1,
          ease: Power1.easeIn,
        })
        .to(
          imageMask,
          {
            height: '80%',
            marker: true,
            ease: Power1.easeIn,
          },
          '0',
        );

      const scene = new ScrollMagic.Scene({
        triggerElement: textStartPoint,
        duration: textStartPoint.clientHeight,
        triggerHook: 0,
      })
        .setTween(textTween)
        .addTo(controllerImageTextModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Show text' });
      }
    };

    // ----
    // Init All scene
    // ----
    const initAllScenes = () => {
      enlargeImageScene();
      stickyImageScene();
      showTextScene();
    };

    initAllScenes();
  });
}
